const MobilePages = {
  LANDING_SELECTION: 'LANDING_SELECTION',
  WEIGHT_NOTE_SELECTION: 'WEIGHT_NOTE_SELECTION',
  WEIGHT_NOTE_DETAILS: 'WEIGHT_NOTE_DETAILS'
};

export default MobilePages;